<template>
  <header
    class="header"
    :class="{
      'header-home': isHomePage,
      'header-scrolled': isScrolled && isHomePage,
    }"
  >
    <div class="header-container">
      <div class="logo" style="width: 60px; height: 60px; overflow: hidden">
        <img
          src="/shcdlogo.png"
          alt="Logo"
          class="logo-image"
          style="width: 100%; height: auto"
        />
      </div>
      <nav class="nav">
        <ul class="nav-menu">
          <li class="nav-item">
            <router-link to="/" class="nav-link">{{
              t("header.home")
            }}</router-link>
          </li>

          <li class="nav-item has-submenu">
            <router-link to="/company" class="nav-link">{{
              t("header.company.title")
            }}</router-link>
            <div class="submenu">
              <router-link to="/company/introduction" class="submenu-item">{{
                t("header.company.introduction")
              }}</router-link>
              <router-link to="/company/dream" class="submenu-item">{{
                t("header.company.dream")
              }}</router-link>
              <router-link to="/company/events" class="submenu-item">{{
                t("header.company.events")
              }}</router-link>
              <router-link to="/company/partners" class="submenu-item">{{
                t("header.company.partners")
              }}</router-link>
              <router-link to="/company/honors" class="submenu-item">{{
                t("header.company.honors")
              }}</router-link>

              <router-link to="/company/structure" class="submenu-item">{{
                t("header.company.structure")
              }}</router-link>
            </div>
          </li>

          <li class="nav-item has-submenu">
            <router-link to="/products" class="nav-link">{{
              t("header.products.title")
            }}</router-link>
            <div class="submenu">
              <router-link to="/products/tape" class="submenu-item">{{
                t("header.products.tape")
              }}</router-link>
              <router-link to="/products/performance" class="submenu-item">{{
                t("header.products.performance")
              }}</router-link>
              <router-link to="/products/advantages" class="submenu-item">{{
                t("header.products.advantages")
              }}</router-link>
              <router-link to="/products/service" class="submenu-item">{{
                t("header.products.service")
              }}</router-link>
            </div>
          </li>
          <li class="nav-item has-submenu">
            <router-link to="/applications" class="nav-link">{{
              t("header.applications.title")
            }}</router-link>
            <div class="submenu">
              <router-link to="/applications/nuclear" class="submenu-item">{{
                t("header.applications.nuclear")
              }}</router-link>
              <router-link to="/applications/power" class="submenu-item">{{
                t("header.applications.power")
              }}</router-link>
               <router-link to="/applications/magnetic" class="submenu-item">{{
                t("header.applications.magnetic")
              }}</router-link>
              
            </div>
          </li>
          <li class="nav-item has-submenu">
            <router-link to="/news" class="nav-link">{{
              t("header.news.title")
            }}</router-link>
            <div class="submenu">
              <router-link to="/news/company" class="submenu-item">{{
                t("header.news.company")
              }}</router-link>
              <router-link to="/news/downloads" class="submenu-item">{{
                t("header.news.downloads")
              }}</router-link>
            </div>
          </li>

          <li class="nav-item">
            <router-link to="/recruit" class="nav-link">{{
              t("header.recruit")
            }}</router-link>
          </li>

          <li class="nav-item has-submenu">
            <router-link to="/contact" class="nav-link">{{
              t("header.contact.title")
            }}</router-link>
            <div class="submenu">
              <router-link to="/contact/postdoc" class="submenu-item">{{
                t("header.contact.postdoc")
              }}</router-link>
              <router-link to="/contact/info" class="submenu-item">{{
                t("header.contact.info")
              }}</router-link>
            </div>
          </li>
        </ul>
      </nav>
      <div class="function-area">
        <button
          class="btn"
          @click="handleLocaleChange(locale === 'zh-CN' ? 'en-US' : 'zh-CN')"
        >
          {{ t("buttons.language") }}
        </button>
         <!-- <button class="btn" @click="openSearch">
          {{ t('search.button') }}
        </button> -->
      </div>
    </div>
  </header>

  <!-- <SearchModal :is-visible="isSearchVisible" @close="closeSearch" /> -->
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import SearchModal from "./SearchModal.vue";
import { useLangStore } from "../../pinia/stores/lang";

const { t, locale } = useI18n();
const route = useRoute();
const isScrolled = ref(false);
const isSearchVisible = ref(false);
const langStore = useLangStore();

const isHomePage = computed(() => route.path === "/");

const handleScroll = () => {
  isScrolled.value = window.scrollY > window.innerHeight - 60;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const handleLocaleChange = (value: string) => {
  locale.value = value;
  // 同步到Pinia
  langStore.setLang(value);
};

const openSearch = () => {
  isSearchVisible.value = true;
};

const closeSearch = () => {
  isSearchVisible.value = false;
};
</script>

<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    transform: translateY(-100%);
    transition: transform 0.3s ease;
    z-index: -1;
  }

  &:hover::before {
    transform: translateY(0);
  }

  &-home {
    background: transparent;
    box-shadow: none;

    &::before {
      background: rgba(255, 255, 255, 0.98);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    .nav-link {
      color: #fff;
      position: relative;
      z-index: 1;

      &:hover {
        color: #333;
      }
    }

    .logo-text {
      color: #fff;
      position: relative;
      z-index: 1;

      &:hover {
        color: #333;
      }
    }

    .btn {
      color: #fff;
      border-color: #fff;
      position: relative;
      z-index: 1;

      &:hover {
        color: #333;
        border-color: #333;
      }
    }

    &:hover {
      .nav-link {
        color: #333;
      }

      .logo-text {
        color: #333;
      }

      .btn {
        color: #333;
        border-color: #333;
      }
    }

    .submenu {
      background: rgba(255, 255, 255, 0.98);

      .submenu-item,
      .submenu-title {
        color: #333;
      }
    }
  }

  &-scrolled {
    background: transparent;
    box-shadow: none;

    &::before {
      background: #fff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transform: translateY(0);
    }

    .nav-link {
      color: #333;
    }

    .btn {
      color: #333;
      border-color: #333;
    }
  }
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  height: 40px;
  display: flex;
  align-items: center;

  .logo-text {
    font-size: 20px;
    font-weight: bold;
    text-decoration: none;
    transition: color 0.3s ease;
    color: #333;
  }
}

.nav {
  flex: 1;
  display: flex;
  justify-content: center;
}

.nav-menu {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 20px;
}

.nav-item {
  position: relative;
  height: 60px;
  display: flex;
  align-items: center;

  &.has-submenu {
    &:hover .submenu {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
}

.nav-link {
  font-size: 16px;
  text-decoration: none;
  color: #333;
  transition: color 0.3s ease;
  padding: 0 15px;
  height: 100%;
  display: flex;
  align-items: center;

  &:hover,
  &.router-link-active {
    color: #1890ff;
  }
}

.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 200px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.3s ease;
}

.submenu-item {
  display: block;
  padding: 8px 20px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s ease;
  white-space: nowrap;

  &:hover {
    color: #1890ff;
    background: #f5f7fa;
  }
}

.submenu-group {
  padding: 8px 0;
  border-top: 1px solid #eee;
}

.submenu-title {
  padding: 8px 20px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.submenu-content {
  padding: 4px 0;
}

.function-area {
  display: flex;
  gap: 12px;
}

.btn {
  padding: 8px 16px;
  border: 1px solid #333;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
}

@media screen and (max-width: 768px) {
  .header {
    display: none;
  }
}

@media screen and (min-width: 769px) {
  .header-container {
    padding: 0 20px;
  }

  .logo .logo-text {
    font-size: 16px;
  }

  .nav-link {
    font-size: 14px;
    padding: 0 10px;
  }
}
</style>
